import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '../../components';

export function NewWillSuccessScreen() {
  const navigate = useNavigate();

  const handleCancel = useCallback(() => {
    navigate('/home');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    navigate('../add-beneficiaries');
  }, [ navigate ]);

  return (
    <div className="new-will-success-screen">
      <h2>Success</h2>
      <p>Your changes have been saved successfully.</p>

      <div className="button-container">
        <Button onClick={handleCancel}>Cancel</Button>
        <Button onClick={handleNext}>Next</Button>
      </div>
    </div>
  );
}
